// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./scripts/sections/collection.ts")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./styles/sections/collection.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
